import store from '@/store';

export function generateMetaXML() {

const title = store.state.emailTitle
let path = store.state.path.map(obj => obj.label).join('/');
if (!path) path = 'root'
console.log(path, store.state.path)
const fullPath = `${path}/${title}`
const currentDateISO = new Date().toISOString().split('T')[0];
const user= store.state.user	

return `<?xml version='1.0' encoding='utf-8'?>
<meta version="main" build="32048">
	<export at='${currentDateISO}' by='${user}'>
		<comment>
			<![CDATA[deploy package]]>
		</comment>
	</export>
	<template created_by='${user}' created_at='${currentDateISO}' changed_by='${user}' changed_at='${currentDateISO}'>
		<name>
			<![CDATA[${title}]]>
		</name>
		<path>
			<![CDATA[${fullPath}]]>
		</path>
	</template>
</meta>`; 
}
